import React from 'react'
import TermsHero from '../component/TermsHero'
import ContactSection from '../component/ContactSection'
import CompleteTerms from '../component/CompleteTerms'

const TermsAndConditions = () => {
  return (
    <>
    <TermsHero/>
    <CompleteTerms/>
    <ContactSection/>
    </>
  )
}

export default TermsAndConditions
